import styled from 'styled-components';

import {Background} from './Background';

export const FullScreen = styled(Background)`
position: fixed;
height: 100%;
width: 100%;
`;
